module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/battle-payments-reward-100.19fc230b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/battle-payments-reward-100.png
// module id = 3780
// module chunks = 11